import React, { useEffect } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

import { getUserImagePath } from "helpers/imageService"

//redux
import { useSelector, useDispatch } from "react-redux"

import profileImg from "../../assets/images/profile-img.png"
import { useUserDetail } from "hooks"

//import action
import { addLMSProfile as onAddLMSProfile } from "../../store/actions"
import { isEmpty } from "lodash"

const WelcomeComp = () => {
  const dispatch = useDispatch()
  const { userprofile } = useUserDetail()

  //////////////////BASIC SETTING STATE/////////////////////
  const { basicSetting } = useSelector(state => state.Layout)
  //////////////////////////////////////

  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary-subtle">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">Welcome Back !</h5>
                <p>Center Dashboard</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="5">
              <div className="avatar-md profile-user-wid mb-4">
                <img
                  alt={userprofile.Name}
                  src={getUserImagePath(userprofile.RowID, "image.jpeg")}
                  className="img-thumbnail rounded-circle"
                />
              </div>
              <h5 className="font-size-15">{userprofile?.Name}</h5>
              <p className="text-muted mb-0">{userprofile?.RoleType}</p>
            </Col>

            <Col sm="7">
              <div className="pt-4">
                <div className="mt-4">
                  <Link to="/profile" className="btn btn-primary  btn-sm">
                    View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
export default WelcomeComp
